import { contentManagementService } from '../service';
import _ from 'lodash';
import { setScheduledTestFetchData } from '../components/coursePlan/helpers/goalsAndTest';
import { findMaxChapterCount } from '../components/treeComponents/helper';

export const setGetPackageById = ({ id, setPackageById, setPackages, setScheduledTestData, setBasicInfo }: any,
    renderDataForStandardCourse?: Function) => {
    contentManagementService.getPackageById(id).then((response: any) => {
        const { responseObject = {} } = response;
        responseObject &&
            responseObject.packageData &&
            responseObject.packageData.coursePlanId &&
            setScheduledTestFetchData(responseObject.packageData.coursePlanId, setScheduledTestData);
        console.log('::::::::::::Inside:::::::::::::::::SetapackageById:::::');
        setPackageById({ packageByIdData: { ...responseObject } });
        setBasicInfo && setBasicInfo(responseObject.packageData);
        const { packageData = {} } = responseObject;
        const { courseDetails = [], type = '', coursePlanId = null } = packageData;
        const goals = _.map(courseDetails, 'courseId').join(',');
        !coursePlanId ? getListOfCourses({ goals, type, pageNumber: '1' }, setPackages) : renderDataForStandardCourse && renderDataForStandardCourse(coursePlanId);
    });
};

const getParams = (queryData: any): any => {
    let queryKeys = Object.keys(queryData);
    let queryObject = {};
    queryKeys.forEach((ele: any) => {
        queryObject = { ...queryObject, [ele]: queryData[ele] }
    })
    return queryObject;
}

export const getListOfCourses = (queryData: any, setPackages: Function) => {
    contentManagementService.getPackageTemplates(getParams(queryData)).then((response: any) => {
        const { responseObject = {} } = response;
        setPackages({ packages: { ...responseObject } });
        Promise.resolve(response);
    });
}

export const checkTreeDataValidation = (treeData: any, isScheduleTest?: boolean) => {
    let hasContentHaveData = true;
    const { phases = [] } = treeData;
    phases.forEach((phase: any) => {
        const { weeks = [] } = phase;
        const { milestoneTests = [] } = phase;
        // if(isScheduleTest && !hasMileStoneTest(milestoneTests)){
        //     hasContentHaveData = false;
        // }
        weeks && weeks.length && weeks.forEach((week: any) => {
            const { subjects = [] } = week;
            subjects && subjects.length && subjects.forEach((subject: any) => {
                const { chapters = [] } = subject;
                chapters && chapters.length && chapters.forEach((chapter: any) => {
                    const { concepts = [] } = chapter;
                    concepts && concepts.length && concepts.forEach((concept: any) => {
                        const { content = [] } = concept;
                        // if (!hasData(content)) {
                        //     hasContentHaveData = false;
                        // }
                    });
                });
            });
        });
    });
    console.log({ hasContentHaveData });
    return hasContentHaveData;
}

const hasMileStoneTest = (mileStoneTest: any) => {
    // commented below code as per required in 2292
    if (mileStoneTest && mileStoneTest.length) {
        return true;
    }
    return false;
}
const hasData = (content: any) => {
    // commented below code as per required in 2292
    // if (content && content.length) {
    //     return true;
    // }
    return true;
}


export const cleanDataForPayload = (phases: any) => {
    let clonePhases = JSON.parse(JSON.stringify(phases));
    phases &&
        phases.length &&
        phases.forEach((phase: any, indexOfPhase: number) => {
            clonePhases[indexOfPhase].milestoneTests = [];
            const { weeks = [] } = phase;
            weeks && weeks.length && weeks.forEach((week: any, indexOfWeek: number) => {
                const { subjects = [] } = week;
                subjects && subjects.length && subjects.forEach((subject: any, indexOfSubject: number) => {
                    const { chapters = [] } = subject;
                    chapters && chapters.length && chapters.forEach((chapter: any, indexOfChapter: number) => {
                        const { concepts = [] } = chapter;
                        clonePhases[indexOfPhase]
                        ['weeks'][indexOfWeek]
                        ['subjects'][indexOfSubject]
                        ['chapters'][indexOfChapter].content = [];
                        concepts && concepts.length && concepts.forEach((concept: any, indexOfConcept: number) => {
                            clonePhases[indexOfPhase]
                            ['weeks'][indexOfWeek]
                            ['subjects'][indexOfSubject]
                            ['chapters'][indexOfChapter]
                            ['concepts'][indexOfConcept].content = [];
                        });
                    });
                });
            });
        });
    return clonePhases;
}

export const hasEmptyWeeks = (phases: any) => {
    let phaseWithEmptyWeeks: string[] = [];
    phases && phases.length && phases.forEach((phase: any) => {
        const maxChapterCount = findMaxChapterCount(phase);
        if (!phase.isRevision && maxChapterCount < phase.weeks.length) {
          phaseWithEmptyWeeks.push(phase.name)
        }
    })
    return phaseWithEmptyWeeks;
}

